module.exports = __webpack_public_path__ + "img/userB19.b0189edd.jpg";